import { Plugin, PluginKey } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'
import { ActionsPluginProps, ActionsView } from './actions-plugin-view'

export interface HoverActionsPluginProps extends ActionsPluginProps {
  type: string
  matchClasses?: string[]
}

type HoverActionsViewProps = HoverActionsPluginProps & {
  view: EditorView
  matchClasses?: string[]
}

class HoverActionsView extends ActionsView {
  public matchClasses: string[] = ['bshb-inline-mark']
  public shouldShow: Exclude<HoverActionsPluginProps['shouldShow'], null> =
    () => {
      const someClassMatch =
        this.matchClasses?.some(
          (className) =>
            this.hoveredElement?.className.includes(className) ||
            this.hoveredElement?.parentElement?.className.includes(className) ||
            this.hoveredElement?.parentElement?.parentElement?.className.includes(
              className
            )
        ) ?? false
      return someClassMatch
    }

  constructor({
    matchClasses = [],
    ...hoverActionsViewProps
  }: HoverActionsViewProps) {
    super(hoverActionsViewProps)
    this.matchClasses = matchClasses
  }
}

export const BasehubMarkHoverPlugin = (options: HoverActionsPluginProps) => {
  return new Plugin({
    key:
      typeof options.pluginKey === 'string'
        ? new PluginKey(options.pluginKey)
        : options.pluginKey,
    view: (view) => new HoverActionsView({ view, ...options }),
  })
}
